export default "__VITE_ASSET__32cf5064__"